export default __webpack_public_path__ + "static/media/NH투자증권.c4515f2e.svg";